const CATEGORY_UNSPLASH = {
  ecommerce: [
    '1441986300917-64674bd600d8', '1472851294608-062f824d29cc', '1556742049-0cfed4f6a45d',
    '1460925895917-afdab827c52f', '1607082349566-187342175e2f', '1445205170230-053b83016050',
    '1523275335684-37898b6baf30', '1563013544-824ae1b704d3', '1441986300917-64674bd600d8',
  ],
  restaurant: [
    '1517248135467-4c7edcad34c4', '1414235077428-338989a2e8c0', '1555396273-367ea4eb4db5',
    '1552566626-52f8b828add9', '1504674900247-0877df9cc836', '1555939594-58d7cb561ad1',
    '1514933656502-8b0f7548d1f0', '1551218808-94e220e084d2', '1517248135467-4c7edcad34c4',
  ],
  business: [
    '1486406146926-c627a92ad1ab', '1497366216548-37526070297c', '1497215728101-856f4ea42174',
    '1507003211169-0a1dd7228f2d', '1521737604893-d14cc237f11d', '1589829545856-d10d557cf95f',
    '1554224155-6726b3ff858f', '1553877522-43269d4ea984', '1486406146926-c627a92ad1ab',
  ],
  portfolio: [
    '1513364776144-60967b0f800f', '1561070791-2526d30994b5', '1541961017774-22349e4a1262',
    '1558655146-d09347e92766', '1550745165-9bc0b252726f', '1485846234645-a62644f84728',
    '1513364776144-60967b0f800f', '1561070791-2526d30994b5', '1541961017774-22349e4a1262',
  ],
  blog: [
    '1499750310107-5fef28a66643', '1488190211105-8b0e65b80b4e', '1455390582262-044cdead277a',
    '1432821596592-e2c18b78144f', '1486312338219-ce68d2c6f44d', '1504711331087-586921744164',
    '1497633762265-9d179a990aa6', '1524997248093-276114d1795f', '1499750310107-5fef28a66643',
  ],
  landing: [
    '1519389950473-47ba0277781c', '1559136555-9303baea8ebd', '1460925895917-afdab827c52f',
    '1551434678-e076c223a692', '1531297484001-d7adee800089', '1557804506-669a67965ba0',
    '1522071820081-009f0129c71c', '1552664730-d307ca884978', '1600880292203-757bb62b4baf',
  ],
  agency: [
    '1522071820081-009f0129c71c', '1552664730-d307ca884978', '1600880292203-757bb62b4baf',
    '1542744094-3a31f272c490', '1553877522-43269d4ea984', '1559136555-9303baea8ebd',
    '1517248135467-4c7edcad34c4', '1522071820081-009f0129c71c', '1552664730-d307ca884978',
  ],
  personal: [
    '1507003211169-0a1dd7228f2d', '1494790108377-be9c29b29330', '1519345182560-3f2917c472ef',
    '1534528741775-53994a69daeb', '1500648767791-00dcc994a43e', '1524504388940-93e5de64c00c',
    '1539576115442-7cdb58c9f5a4', '1506794778202-cad84cf45f1d', '1517841905240-472988babfe9',
  ],
  event: [
    '1492684223066-81342ee5ff30', '1505236858219-8359eb29e329', '1501281668745-f7f57925c3b4',
    '1492684223066-81342ee5ff30', '1505236858219-8359eb29e329', '1501281668745-f7f57925c3b4',
    '1492684223066-81342ee5ff30', '1505236858219-8359eb29e329', '1501281668745-f7f57925c3b4',
  ],
  realestate: [
    '1560518883-ce09059eeffa', '1570129477492-45c003edd2be', '1512917774080-9991f1c4c750',
    '1600585154340-be6161a56a0c', '1600596542815-ffad4c1539a9', '1600607687929-4e2a09ad0ae5',
    '1605276374102-a276987b845c', '1600047509807-ba139f63fbe6', '1600585154526-990dced4db0d',
  ],
  saas_tech: [
    '1518770660439-4636190af475', '1550751827-4bd374c3f58b', '1451187580459-43490279c0fa',
    '1488590528505-98d2b5aba04b', '1519389950473-47ba0277781c', '1551288049-bebda4e38f71',
    '1517245386807-bb43f82c33c4', '1515378791036-0648a3ef77b2', '1553877522-43269d4ea984',
  ],
  health_fitness: [
    '1534438327276-14e5300c3a48', '1571019613454-1cb2f99b2d8b', '1517836357463-d25dfeac3438',
    '1540497077202-7c8a3999166f', '1576678927484-cc907957088c', '1518611012113-696072aa579a',
    '1538805069517-41515b451c91', '1571907520771-624f5111c1c9', '1534438327276-14e5300c3a48',
  ],
  education: [
    '1503676260728-1c00da094a0b', '1524178232363-1fb2b075b655', '1497633762265-9d179a990aa6',
    '1509062522246-3755977927d7', '1523240794102-9fdf2c70e0c2', '1522202176988-66273c2fd55f',
    '1434030212631-512b39f17774', '1503676260728-1c00da094a0b', '1524178232363-1fb2b075b655',
  ],
  spa_salon: [
    '1596462502278-27bfdc403348', '1522335789203-aabd1fc54bc9', '1540555700882-e63e8ee6224d',
  ],
  handyman: [
    '1581578731548-c64695cc6952', '1504307651254-356700af0cc2', '1560518883-ce09059eeffa',
  ],
  cleaning: [
    '1581578731548-c64695cc6952', '1504307651254-356700af0cc2', '1560518883-ce09059eeffa',
  ],
  automotive: [
    '1492144534655-ae79c964c9d7', '1486262715619-67b85e0b08d0', '1503376780353-7f669629ca41',
  ],
  pet_services: [
    '1450778869180-41d0601e046e', '1587300003388-59208cc962cb', '1516737862287-1295891181c8',
  ],
  landscaping: [
    '1416879595882-3373a0480b5b', '1459411552884-841db9b3cc2a', '1463936575829-25148e1db1b8',
  ],
  plumbing_hvac: [
    '1581094794329-c8112a89af12', '1621905252507-b35492cc74b4', '1581578731548-c64695cc6952',
  ],
  beauty_barber: [
    '1503950198299-560369af922e', '1622286342621-14fd0f43a41e', '1521594698603-1c7c2d76a1d6',
  ],
  photography: [
    '1452587925148-ce544e77e70d', '1516035069371-29a1b244cc32', '1472099645785-5658abf4ff4e',
  ],
  moving_storage: [
    '1600517180661-283463544110', '1600880292203-757bb62b4baf', '1586528116311-ad8dd3c8310d',
  ],
};

export const CATEGORY_THEMES = {
  restaurant: { accent: '#f59e0b', badge: '🍽️' },
  ecommerce: { accent: '#a855f7', badge: '🛍️' },
  business: { accent: '#3b82f6', badge: '💼' },
  saas_tech: { accent: '#6366f1', badge: '💻' },
  portfolio: { accent: '#ec4899', badge: '🎨' },
  landing: { accent: '#10b981', badge: '🚀' },
  blog: { accent: '#d97706', badge: '✍️' },
  health_fitness: { accent: '#22c55e', badge: '💪' },
  education: { accent: '#0ea5e9', badge: '📚' },
  realestate: { accent: '#14b8a6', badge: '🏠' },
  event: { accent: '#d946ef', badge: '🎉' },
  agency: { accent: '#f43f5e', badge: '🏢' },
  personal: { accent: '#fb923c', badge: '👤' },
  spa_salon: { accent: '#a855f7', badge: '💆' },
  handyman: { accent: '#f97316', badge: '🔧' },
  cleaning: { accent: '#0ea5e9', badge: '✨' },
  automotive: { accent: '#ef4444', badge: '🚗' },
  pet_services: { accent: '#f59e0b', badge: '🐾' },
  landscaping: { accent: '#22c55e', badge: '🌿' },
  plumbing_hvac: { accent: '#0284c7', badge: '🚿' },
  beauty_barber: { accent: '#78716c', badge: '💈' },
  photography: { accent: '#6366f1', badge: '📷' },
  moving_storage: { accent: '#3b82f6', badge: '📦' },
};

function stableHash(value) {
  let hash = 0;
  const text = value || '';
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  }
  return hash;
}

function normalizePreviewUrl(url) {
  if (!url) return null;
  const img = String(url).trim();
  if (!/^https?:\/\//i.test(img)) return null;
  if (/picsum\.photos|placehold\.co|placeholder/i.test(img)) return null;
  if (img.includes('unsplash.com')) {
    const base = img.split('?')[0];
    return `${base}?w=800&h=500&fit=crop&auto=format&q=80`;
  }
  return img;
}

export function templatePreviewImage(template, { lockOffset = 0 } = {}) {
  const fromApi = normalizePreviewUrl(template?.preview_image);
  if (fromApi && lockOffset === 0) return fromApi;

  const category = (template?.category || 'business').toLowerCase();
  const ids = CATEGORY_UNSPLASH[category] || CATEGORY_UNSPLASH.business;
  const id = template?.id || template?.name || category || 'template';
  const idx = (stableHash(id) + lockOffset) % ids.length;
  const photoId = ids[idx];
  return `https://images.unsplash.com/photo-${photoId}?w=800&h=500&fit=crop&auto=format&q=80`;
}

export function templatePreviewFallback(template) {
  const category = (template?.category || 'business').toLowerCase();
  const theme = categoryTheme(category);
  const label = encodeURIComponent((template?.name || 'Template').slice(0, 24));
  const accent = theme.accent.replace('#', '');
  return `https://placehold.co/800x500/${accent}/ffffff?text=${label}`;
}

export function templateVariantIndex(template) {
  return stableHash(template?.id || template?.name || 'template') % 4;
}

export function categoryTheme(category) {
  const key = (category || '').toLowerCase();
  return CATEGORY_THEMES[key] || CATEGORY_THEMES.business;
}
